import { render, staticRenderFns } from "./MainCarousel.vue?vue&type=template&id=039e7977"
import script from "./MainCarousel.vue?vue&type=script&lang=ts"
export * from "./MainCarousel.vue?vue&type=script&lang=ts"
import style0 from "./MainCarousel.vue?vue&type=style&index=0&id=039e7977&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports